import { useAppSelector } from 'app/hooks';
import FeatureTitleBar from 'components/common/FeatureTitleBar';
import { selectIsEditMode } from 'features/common/editModeSlice';
import { SubGenre } from 'features/SubGenre/models/SubGenre';
import SubGenreFormDetail from 'features/SubGenre/pages/detail/components/SubGenreFormDetail';
import { Modal } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';

interface EditModalInterface {
  sub_genre: SubGenre;
  show: boolean;
  handleCloseModalEdit: (status: boolean, data?: SubGenre) => void;
}

function DetailModal({ sub_genre, show, handleCloseModalEdit }: EditModalInterface) {
  const { t } = useTranslation();

  // selectors
  const isEditMode = useAppSelector(selectIsEditMode);

  function onHide() {
    handleCloseModalEdit(false);
  }

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton className={isEditMode ? 'reedit-mode-wrapper' : ''}>
        <FeatureTitleBar title={t('SubGenre.Form.title')} />
      </Modal.Header>
      <Modal.Body className={isEditMode ? 'reedit-mode-wrapper' : ''}>
        {sub_genre && (
          <SubGenreFormDetail
            subGenre={sub_genre}
            id={sub_genre.id.toString()}
            handleCloseModalEdit={handleCloseModalEdit}
          />
        )}
      </Modal.Body>
    </Modal>
  );
}
export default DetailModal;
